import { Injectable } from '@angular/core';
import { ChangeTyped, ISSUE_MEDIAS_STORE } from '@damofire/data-commons';
import { Observable } from 'rxjs';
import { ObservableSyncService } from '../sync/observable-sync.service';
import { ObservableIssueMediaService } from './issue-media-observable.service';
import { IdbIssueMedia } from './issue.dto';

@Injectable()
export class IdbObservableIssueMediaService extends ObservableIssueMediaService {
  constructor(protected readonly observableSyncService: ObservableSyncService<IdbIssueMedia>) {
    super();
  }

  observeMediaByIssue(division: string, issueId: string): Observable<ChangeTyped<IdbIssueMedia>[]> {
    return this.observableSyncService.toObservableDivisionIndex(
      ISSUE_MEDIAS_STORE,
      'issueId',
      issueId,
      division,
      (docs) => docs.filter((doc) => doc.issue._id === issueId).sort((a, b) => Number(b.audit.createdDate) - Number(a.audit.createdDate)),
      true,
    );
  }
}
